import { render, staticRenderFns } from "./LetterPicker.vue?vue&type=template&id=4edfed96&scoped=true&"
import script from "./LetterPicker.vue?vue&type=script&lang=js&"
export * from "./LetterPicker.vue?vue&type=script&lang=js&"
import style0 from "./LetterPicker.vue?vue&type=style&index=0&id=4edfed96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edfed96",
  null
  
)

export default component.exports